import { useRequest } from "../helpers/useRequest";
import { useQuery } from "react-query";
import { api } from "../config/apiEndpoints";
import { queryEnums } from "../config/queryEnums";
import { DocumentHierarchyDTO } from "types";

const url = api.documents;

export const useGetDocumentDetailsByProject = (projectId?: string) => {
  const { get } = useRequest();
  return useQuery<DocumentHierarchyDTO[]>(
    [queryEnums.document_details_by_project, projectId],
    () => get(`${url}/GetDocumentDetailsFolder/${projectId}`),
    {
      enabled: !!projectId,
    }
  );
};